export default __webpack_public_path__ + "static/media/four.d1115b7b.png";